import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import CaptainSidebar from '../components/CaptainSidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CaptainLayout = ({ onLogout }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setSidebarVisible(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    if (window.innerWidth < 992) {
      setSidebarVisible(prev => !prev);
    } else {
      setSidebarCollapsed(prev => !prev);
    }
  };

  return (
    <div className="d-flex">
      <CaptainSidebar
        collapsed={sidebarCollapsed}
        visible={sidebarVisible}
        onLogout={onLogout}
      />
      {sidebarVisible && (
        <div
          className="sidebar-overlay d-lg-none"
          onClick={() => setSidebarVisible(false)}
        />
      )}
      <div className="flex-grow-1" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header
          onToggleSidebar={toggleSidebar}
          sidebarCollapsed={sidebarCollapsed}
          sidebarVisible={sidebarVisible}
          onLogout={onLogout}
        />
        <div className={`dms-dashboard ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`} style={{ flex: 1, display: 'flex', flexDirection: 'column', marginBottom: 0, paddingBottom: 0 }}>
          <div style={{ flex: 1 }}>
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default CaptainLayout;
